<template>
  <div class="relative">
    <div class="absolute top-0 right-4">
      <feather-icon icon="XIcon" @click="handleClose" />
    </div>
    <div class="w-full pt-5">
      <p class="fsize15">GST No.<span class="clr-red">*</span></p>
      <base-input
        v-model="GST_No"
        placeholder="Enter Name"
        name="First Name"
        class="cust-form-border"
      ></base-input>
    </div>
    <div class="w-full pt-3">
      <p class="fsize15">Commision <span class="clr-red">*</span></p>
      <base-input
        v-model="Commission"
        placeholder="Enter Name"
        name="First Name"
        class="cust-form-border"
      ></base-input>
    </div>
    <div class="w-full pt-3">
      <p class="fsize15">Account No <span class="clr-red">*</span></p>
      <base-input
        v-model="accountNumber"
        placeholder="Enter Name"
        name="First Name"
        class="cust-form-border"
      ></base-input>
    </div>
    <div class="w-full pt-3">
      <p class="fsize15">IFSC Code <span class="clr-red">*</span></p>
      <base-input
        v-model="IFSCCode"
        placeholder="Enter Name"
        name="First Name"
        class="cust-form-border"
      ></base-input>
    </div>
    <div class="pt-5 flex justify-center">
      <button
        class="bg-primary text-white px-8 py-2 rounded"
        @click="handleSubmit"
      >
        Submit
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    vendorData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      bankName: "",
      accountNumber: "",
      IFSCCode: "",
      GST_No: "",
      Commission: "",
    };
  },
  methods: {
    handleClose() {
      this.$bvModal.hide("IsshowVendorDetails");
    },
    async handleSubmit() {
      // console.log(this.vendorData, "8798798");
    },
  },

  mounted() {
    // console.log(this.vendorData);
    // bankName: { type: String },
    // accountNumber: { type: String },
    // IFSCCode: { type: String },
    // GST_No: { type: String },
    // Commission: { type: String },
  },
};
</script>

<style></style>
